export interface KPPost {
  // DB Fields
  uid: number;
  boardUID: number; // 게시판 UID
  subCategoryUID: number; // NEW - 분류 UID
  writerUID: number; // 작성자 UID(로그인된 사용자)
  readCount: number; // 읽은 회수
  title: string; // 게시글 제목
  contents: string; // 게시글 내용
  imageFile: string; // 이미지 파일명
  attachmentFile: string; // 첨부 파일명
  // note 2024-01-19 추가
  linkUrl: string;
  linkName: string;
  isDeleted: boolean;
  entryDate: Date | string;
  modifyDate: Date | string;

  // NOT DB
  writerName: string; // 작성자 명
  boardName: string; // 게시판 명
  base64Image: string; // 이미지 파일 base64
  base64Attachment: string; // 첨부 파일 base64
}

export const initializePost = (boardUID = 0, subCategoryUID = 0): KPPost => {
  return {
    uid: 0,
    boardUID: boardUID,
    subCategoryUID: subCategoryUID,
    writerUID: 0,
    readCount: 0,
    title: "",
    contents: "",
    imageFile: "",
    attachmentFile: "",
    linkUrl: "",
    linkName: "",
    isDeleted: false,
    entryDate: new Date(),
    modifyDate: new Date(),

    // NOT DB
    writerName: "",
    boardName: "",
    base64Image: "",
    base64Attachment: "",
  };
};
